import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense, type ComponentPropsWithoutRef } from "react";

const ChatThreads = lazyWithRetry(() =>
  import(/* webpackChunkName: "RailbarChatThreads" */ "./index").then(
    module => ({ default: module.ChatThreads }),
  ),
);

/** Lazy so Reactions / emoji-js stay off the initial shell graph. */
export const LazyChatThreads = (
  props: ComponentPropsWithoutRef<typeof ChatThreads>,
) => (
  <Suspense fallback={null}>
    <ChatThreads {...props} />
  </Suspense>
);
